import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { loginUser } from '../../store/authSlice';


const initialState = {
    username: '',
    password: ''
}

function AuthLogin() {

    const [formData, setFormData] = useState(initialState);

    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();


    const [isActive, setIsActive] = useState(false);

    // valider si les champs sont remplis
    useEffect(() => {
        setIsActive(formData.username !== '' && formData.password !== '');
    }, [formData]);

    async function onSubmit(event) {
        event.preventDefault();

        const result = await dispatch(loginUser(formData));

        if (result?.payload?.success) {
            console.log(result);
            const from = location.state?.from?.pathname || '/';
            navigate(from, { replace: true });
        }
    }
    return (
        <>
            {/* strat content */}

            <div className="space-y-8 bg-white px-4 py-6 rounded-md w-full max-w-sm">
                <h1 className="font-semibold text-center text-xl">Connexion</h1>
                <form onSubmit={onSubmit} className="space-y-8">
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="text"
                        name="username"
                        onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                        placeholder="Code d'utilisateur ou Email"
                        required
                    />
                    <input
                        className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
                        type="password"
                        name="password"
                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                        placeholder="Password"
                        required
                    />
                    <div className="flex justify-between items-center">

                        <a href="/forgot-password" className="text-sm text-teal-500 hover:underline">Mot de passe oublie ?</a>
                    </div>
                    <div>
                        <button
                            type="submit"
                            disabled={!isActive}
                            className="bg-teal-500 disabled:bg-gray-400 px-4 py-2 rounded-md focus:ring-2 focus:ring-primary focus:ring-offset-1 dark:focus:ring-offset-darker w-full font-medium text-center text-white transition-colors duration-200 focus:outline-none"
                        >
                            Se connecter
                        </button>
                    </div>
                </form>

                <div className="flex flex-nowrap justify-center items-center space-x-2">
                    <span className="bg-gray-300 w-20 h-px"></span>
                    <span>OU</span>
                    <span className="bg-gray-300 w-20 h-px"></span>
                </div>

                <div className="text-gray-600 text-sm dark:text-gray-400">
                    vous n'avez pas de compte ? <a href="/register" className="text-teal-500 hover:underline"> s'enregistrer</a>
                </div>
            </div>

            {/* end content */}
        </>
    )
}

export default AuthLogin